export const SALE_PROGRESS_VARIANTS = {
  DEFAULT: 'default',
  BIG: 'big',
}
